import moment from "moment-timezone";
import { QRCodeSVG } from "qrcode.react";
import React, { useEffect, useMemo, useState } from "react";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { useRecoilState, useRecoilValue } from "recoil";
import { setRecoil } from "recoil-nexus";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import styled from "styled-components";
import { BackButton } from "../../components/BackButton";
import ApiController from "../../controller/ApiController";
import LogController from "../../controller/LogController";
import MessageController from "../../controller/MessageController";
import { authStoreType, masterStoreState } from "../../recoil/auth";
import { selectChatState } from "../../recoil/chat";
import { langState, langText } from "../../recoil/lang";
import { settingsState } from "../../recoil/settings";
import { NewOrderType, refreshOrderState } from "../../recoil/socket";
import {
  ORDER_CANCLE_STATUS,
  ORDER_COM_DEL_STATUS,
  ORDER_COM_STATUS,
  ORDER_READY_STATUS,
  ORDER_START_DEL_STATUS,
  ORDER_WAIT_STATUS,
  OrderDataType,
  PRODUCT_TYPE_DELIVERY,
  PRODUCT_TYPE_RENTAL_SMS,
} from "../../recoil/type";
import {
  contentName,
  formatPhoneNumber,
  getStatusTypeList,
  getStoreName,
  getStoreTypeStatus,
} from "../../utils/util";
import { useBackTimer } from "../../hooks/useBackTimer";

// const test = [
//   {
//     order_id: "OT2CF1BF5F3858840",
//     bill_number: "Q8P04X",
//     area_number: 0,
//     number: 0,
//     area_name: "1층",
//     name: "101호",
//     store_id: 101,
//     store_name: "배가네 순대국ㅇ",
//     store_name_en: "Baegane sundaeguk",
//     phone_number: "022111111",
//     order_seq: 0,
//     order_status: 0,
//     created_at: "2024-11-25T05:21:51.000Z",
//     confirmed_at: "2024-11-25T05:21:51.000Z",
//     prepared_at: "2024-11-25T05:21:51.000Z",
//     completed_at: "2024-11-25T05:21:51.000Z",
//     delivery_expected_at: null,
//     picked_up_at: null,
//     delivery_completed_at: null,
//     arrival_expected_at: null,
//     ordered_at: "2024-11-25T05:21:51.000Z",
//     cancelled_at: "2024-11-25T05:21:51.000Z",
//     cancel_expected_at: null,
//     cancel_description: "",
//     order_category: 0,
//     order_check_type: 0,
//     email: null,
//     customer_phone_number: null,
//   },
// ];

const OrderStatus = () => {
  const navigate = useNavigate();
  const settings = useRecoilValue(settingsState);
  const kioskMode = settings.view.kioskmode.value === "1";
  const [lang, setLang] = useRecoilState<number>(langState);

  const [selectedOrder, setSelectedOrder] = useState<number>(0);

  const [isAnimating, setIsAnimating] = useState<boolean>(false);
  const [callButtonX, setCallButtonX] = useState<number>(0);

  const [orderDataList, setOrderDataList] = useState<OrderDataType[]>([]);
  const orderRefreshFlag = useRecoilValue<NewOrderType>(refreshOrderState);
  const master = useRecoilValue<authStoreType | null>(masterStoreState);
  const [isVisibleCallNumber, setIsVisibleCallNumber] =
    useState<boolean>(false);

  const [statusType, setStatusType] = useState<number[]>([]);

  // 터치 제어 로직
  const { resetTimer } = useBackTimer("orderStatus");

  const navigateMaster: any = () => {
    LogController.click({
      path: "orderStatus",
      params: "click",
      params2: "홈버튼 클릭",
    });
    navigate(`/master`);
  };
  const navigateDetails = (item: OrderDataType) => {
    navigate(`/order`, {
      state: item,
    });
  };

  const handleCustomerServiceClick = () => {
    setRecoil(selectChatState, true);
  };

  const closeOrder = () => {
    setIsAnimating(false);
    setIsVisibleCallNumber(false);
    setSelectedOrder(-1);
  };

  const selectOrder = (index: number) => {
    setIsAnimating(true);
    setIsVisibleCallNumber(false);
    setSelectedOrder(index);

    // window.scrollTo("id:" + index);
  };

  const handleCallButtonClick = (event: React.MouseEvent<HTMLElement>) => {
    const iconRect = event.currentTarget.getBoundingClientRect();
    console.log(iconRect.left, window.scrollX);
    setCallButtonX(iconRect.left + window.scrollX);
    setIsVisibleCallNumber(!isVisibleCallNumber);
  };

  // const endVideo = () => {
  //   const nextIndex = (currentMediaIndex + 1) % mediaData.length;

  //   window.ReactNativeWebView?.postMessage(
  //     MessageController.getEchoData({ nextVideo: mediaData[nextIndex] })
  //   );

  //   setCurrentMediaIndex(nextIndex);
  //   console.log("nextVideo", mediaData[nextIndex]);

  //   if (videoRef.current && mediaData[nextIndex].type === "video") {
  //     videoRef.current!.load();
  //     videoRef.current!.play();
  //   }
  // };

  // const startTimer = () => {
  //   let iIdx = (currentMediaIndex + 1) % mediaData.length;

  //   window.ReactNativeWebView?.postMessage(
  //     MessageController.getEchoData({
  //       now: currentMediaIndex,
  //       next: JSON.stringify(mediaData[iIdx]),
  //     })
  //   );

  //   if (mediaData[currentMediaIndex].type === "image") {
  //     setTimeout(() => {
  //       setCurrentMediaIndex(iIdx);
  //     }, 5 * 1000);
  //   }
  // };

  // API 호출
  const getOrderByUserTokenId = async () => {
    try {
      const oRes: any = await ApiController.order.getOrderByUserTokenId();

      if (oRes && oRes.data) {
        const oResponse: any = oRes.data;
        console.log("getOrderByUserTokenId", oResponse);
        setOrderDataList([...oResponse]);
      }
    } catch (err) {
      console.log("err-->", err);
    }
  };
  const cancelCustomer = async (order_id: string, order_seq: number) => {
    try {
      const oRes: any = await ApiController.order.cancelCustomer(
        order_id,
        order_seq
      );
    } catch (err) {
      console.log("err-->", err);
    }
  };

  useEffect(() => {
    const onAnimationEnd = () => {
      console.log("animateEnd", selectedOrder);
      setIsAnimating(false);

      // document.getElementById("id:"+selectedOrder)?.scrollIntoView();
      // var myElement:any = document.getElementById("id:"+selectedOrder);
      // var topPos:any= myElement.offsetTop;

      // document.getElementById("id:"+selectedOrder)?.scrollTo(topPos)
      // document.getElementById("id:"+selectedOrder).scrollTop = topPos;
    };

    const element = document.querySelector(".listContent");
    if (element) {
      element.addEventListener("animationend", onAnimationEnd);

      return () => {
        element.removeEventListener("animationend", onAnimationEnd);
      };
    }
  }, [selectedOrder]);

  useEffect(() => {
    try {
      LogController.navigate({
        path: "OrderStatus",
        params: "navigate",
        params2: "주문내역",
      });
    } catch (err: any) {
      console.log(err);
    }

    ApiController.order.getOrderByUserTokenId().then((res) => {
      setOrderDataList(res.data);
    });

    window.ReactNativeWebView?.postMessage(
      MessageController.getEchoData({ gogo: "gogo" })
    );

    return () => {
      window.ReactNativeWebView?.postMessage(
        MessageController.getEchoData({ out: "out" })
      );
    };
  }, []);

  useEffect(() => {
    getOrderByUserTokenId();

    if (orderRefreshFlag.order_category) {
      if (orderRefreshFlag.order_status === ORDER_READY_STATUS) {
        toast.success(
          getStoreTypeStatus(
            orderRefreshFlag.order_category,
            orderRefreshFlag.order_status,
            lang
          ).title
        );
      } else if (orderRefreshFlag.order_status === ORDER_START_DEL_STATUS) {
        toast.success(
          getStoreTypeStatus(
            orderRefreshFlag.order_category,
            orderRefreshFlag.order_status,
            lang
          ).title
        );
      }
    }
  }, [orderRefreshFlag]);

  useEffect(() => {
    if (orderDataList.length > 0 && selectedOrder !== -1) {
      const typeListTemp = getStatusTypeList(
        orderDataList[selectedOrder].order_category
      );
      if (typeListTemp) {
        setStatusType([...typeListTemp]);
      }
    }
  }, [orderDataList, selectedOrder]);

  const getRemainTimeComment = (
    order_status: number,
    order_category: number,
    delivery_expected_at: string | null,
    delivery_completed_at: string | null,
    cancelled_at: string | null,
    setRemainComment?: any
  ) => {
    let remainCommentTemp = "";
    if (
      order_category === PRODUCT_TYPE_RENTAL_SMS &&
      (order_status === ORDER_READY_STATUS || order_status === ORDER_COM_STATUS)
    ) {
      if (setRemainComment) {
        setRemainComment(langText.orderStatus_button_complete_sms[lang]);
      }
      remainCommentTemp = langText.orderStatus_button_complete_sms[lang];
    } else if (order_status === ORDER_CANCLE_STATUS && cancelled_at !== null) {
      if (setRemainComment)
        setRemainComment(
          `${moment(new Date(cancelled_at)).format("HH:mm")} ${
            langText.orderStatus_button_cancel[lang]
          }`
        );
      remainCommentTemp = `${moment(new Date(cancelled_at)).format("HH:mm")} ${
        langText.orderStatus_button_cancel[lang]
      }`;
    } else if (
      (order_status === ORDER_COM_DEL_STATUS ||
        order_status === ORDER_COM_STATUS) &&
      delivery_completed_at !== null
    ) {
      if (setRemainComment)
        setRemainComment(
          `${moment(new Date(delivery_completed_at)).format("HH:mm")} ${
            langText.orderStatus_arrived[lang]
          }`
        );
      remainCommentTemp = `${moment(new Date(delivery_completed_at)).format(
        "HH:mm"
      )} ${langText.orderStatus_arrived[lang]}`;
    } else if (delivery_expected_at !== null) {
      if (new Date(delivery_expected_at).getTime() > new Date().getTime()) {
        if (setRemainComment)
          setRemainComment(
            `${langText.orderStatus_remainTime[lang]} ${String(
              Math.floor(
                (new Date(delivery_expected_at).getTime() -
                  new Date().getTime()) /
                  (1000 * 60)
              )
            ).padStart(2, "0")}${langText.minute[lang]}`
          );
        remainCommentTemp = `${langText.orderStatus_remainTime[lang]} ${String(
          Math.floor(
            (new Date(delivery_expected_at).getTime() - new Date().getTime()) /
              (1000 * 60)
          )
        ).padStart(2, "0")}${langText.minute[lang]}`;
      } else {
        if (setRemainComment)
          setRemainComment(
            `${String(
              Math.floor(
                (new Date().getTime() -
                  new Date(delivery_expected_at).getTime()) /
                  (1000 * 60)
              )
            ).padStart(2, "0")}${langText.minute[lang]} ${
              langText.orderStatus_exceed[lang]
            }`
          );
        remainCommentTemp = `${String(
          Math.floor(
            (new Date().getTime() - new Date(delivery_expected_at).getTime()) /
              (1000 * 60)
          )
        ).padStart(2, "0")}${langText.minute[lang]} ${
          langText.orderStatus_exceed[lang]
        }`;
      }
    } else {
      if (setRemainComment)
        setRemainComment(langText.orderStatus_processing[lang]);
      remainCommentTemp = langText.orderStatus_processing[lang];
    }
    return remainCommentTemp;
  };

  const RenderOpenItem = (oProps: { item: OrderDataType; index: number }) => {
    const [remainComment, setRemainComment] = useState<string>(
      getRemainTimeComment(
        oProps.item.order_status,
        oProps.item.order_category,
        oProps.item.delivery_expected_at,
        oProps.item.delivery_completed_at,
        oProps.item.cancelled_at
      )
    );

    useEffect(() => {
      let interval: NodeJS.Timeout;

      interval = setInterval(() => {
        getRemainTimeComment(
          oProps.item.order_status,
          oProps.item.order_category,
          oProps.item.delivery_expected_at,
          oProps.item.delivery_completed_at,
          oProps.item.cancelled_at,
          setRemainComment
        );
      }, 1000);

      return () => {
        clearInterval(interval);
      };
    }, []);

    console.log(
      "oProps.item----->",
      oProps.item,
      getStoreTypeStatus(
        oProps.item.order_category,
        oProps.item.order_status,
        lang
      )
    );

    const qrCodeLink = () => {
      if (process.env.REACT_APP_ENV === "PRD") {
        return `https://knock-knock.ivid.kr/store/manager/order/status/${oProps.item.order_id}`;
      } else {
        return `https://knock-ceo.stg.ivid.co.kr/order/status/${oProps.item.order_id}`;
      }
    };
    return (
      <div className="maxWidth">
        <div
          className={`callNumberBox ${isVisibleCallNumber && "visible"}`}
          style={{ left: callButtonX - 77 }}
        >
          {formatPhoneNumber(oProps.item.phone_number)}
        </div>
        <div
          key={oProps.index}
          className={`listItem open ${
            oProps.item.order_status === ORDER_CANCLE_STATUS && "cancel"
          }`}
        >
          <div className="row">
            <p className="indexBox">{oProps.index + 1}</p>
            <div className="row storeInfo">
              <p className="storeName">{getStoreName(oProps.item, lang)}</p>
              <img
                onClick={handleCallButtonClick}
                src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_call.svg`}
                alt="매장 전화번호 아이콘"
              />
            </div>
          </div>
          <div className="row">
            {oProps.item.order_status !== ORDER_CANCLE_STATUS && (
              <>
                {oProps.item.order_status === ORDER_WAIT_STATUS ? (
                  <button
                    className="orderDetailButton cancel"
                    onClick={async () => {
                      await cancelCustomer(
                        oProps.item.order_id,
                        oProps.item.order_seq
                      );
                    }}
                  >
                    <img
                      src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_closeRed.svg`}
                      alt="닫기아이콘"
                    />
                    {langText.orderStatus_button_cancel[lang]}
                  </button>
                ) : (
                  oProps.item.order_category === PRODUCT_TYPE_DELIVERY && (
                    <div className="orderDetailButton notice">
                      {langText.order_cancel_notice[lang]}
                    </div>
                  )
                )}
              </>
            )}
            <img
              src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_arrow_up.svg`}
              alt="열고 닫기 아이콘"
              onClick={closeOrder}
            />
          </div>
        </div>
        <div className={`listContent  ${isAnimating && "active"}`}>
          <div className="topButtonWrap flex">
            <button
              className={`sideButton contact`}
              onClick={handleCustomerServiceClick}
            >
              <img
                src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_service.svg`}
                alt="고객센터"
              />
              <img
                className="siren"
                src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_siren.svg`}
                alt="siren"
              />
              <div className="request">
                <p>{langText.customer_service[lang]}</p>
              </div>
            </button>
            <button
              className="orderDetailButton"
              onClick={() => {
                navigateDetails(oProps.item);
              }}
            >
              <p>{langText.orderStatus_button_history[lang]}</p>
            </button>
          </div>
          <div className="loadingDots">
            {oProps.item.order_status === ORDER_COM_DEL_STATUS ||
            oProps.item.order_status === ORDER_COM_STATUS ? (
              <img
                src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_ok.svg`}
                alt="ic"
              />
            ) : oProps.item.order_category === PRODUCT_TYPE_RENTAL_SMS &&
              oProps.item.order_status === ORDER_READY_STATUS ? (
              <div />
            ) : oProps.item.order_status === ORDER_CANCLE_STATUS ? (
              <img
                src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_cancel.svg`}
                alt="ic"
              />
            ) : (
              <>
                <div className="dot" />
                <div className="dot" />
                <div className="dot" />
              </>
            )}
          </div>
          <h2>
            {
              getStoreTypeStatus(
                oProps.item.order_category,
                oProps.item.order_status,
                lang
              ).title
            }
          </h2>
          {oProps.item.order_status === ORDER_WAIT_STATUS && (
            <p className="cancelNoticeText">{langText.cancel_notice[lang]}</p>
          )}
          <div className="statusBox">
            {oProps.item.order_status === ORDER_CANCLE_STATUS ? (
              <>
                <h3>{`${langText.orderCancelModal_reason[lang]} : ${contentName(
                  oProps.item.cancel_description,
                  lang
                )}`}</h3>

                <h4>{`${
                  oProps.item.order_category === PRODUCT_TYPE_DELIVERY
                    ? langText.orderStatus_content_cancel[lang]
                    : langText.orderStatus_content_cancel_other[lang]
                }`}</h4>
                {/* <div className="refundButton">
                  {langText.orderStatus_button_cancelled[lang]}
                </div> */}
              </>
            ) : (
              <>
                <div className="restTime">
                  <p
                    className={`timeItem ${
                      (oProps.item.order_status === ORDER_COM_STATUS ||
                        oProps.item.order_status === ORDER_COM_DEL_STATUS ||
                        (oProps.item.order_category ===
                          PRODUCT_TYPE_RENTAL_SMS &&
                          oProps.item.order_status === ORDER_READY_STATUS)) &&
                      "inactive"
                    }`}
                  >
                    <img
                      src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_clock.svg`}
                      alt="ic"
                    />
                    {remainComment}
                  </p>
                </div>
                <div className="statusBarWrap">
                  <div className="statusBar">
                    <div
                      className="progressBar"
                      style={{
                        width: `${
                          getStoreTypeStatus(
                            oProps.item.order_category,
                            oProps.item.order_status,
                            lang
                          ).position
                        }%`,
                      }}
                    />
                  </div>
                  <div className="statusWrap">
                    {statusType.map((item, index) => (
                      <div
                        key={index}
                        className="statusDotWrap"
                        style={{
                          left: `${
                            getStoreTypeStatus(
                              oProps.item.order_category,
                              item,
                              lang
                            ).button_position
                          }%`,
                        }}
                      >
                        {oProps.item.order_status === item && (
                          <div className="statusDot" />
                        )}
                        <p className="statusFont">
                          {
                            getStoreTypeStatus(
                              oProps.item.order_category,
                              item,
                              lang
                            ).button
                          }
                        </p>
                      </div>
                    ))}
                  </div>
                </div>
              </>
            )}
          </div>
          {kioskMode && (
            <div className="kioskModeWrap">
              <div className="kioskModeLeft">
                <h3 className="roomNumber">
                  {oProps.item.area_name} {oProps.item.name}
                </h3>
                <h4 className="qrNoticeText">
                  {langText.qrcode_main_notice[lang]}
                </h4>
                <div className="flex">
                  <p>{langText.qrcode_sub_notice[lang]}</p>
                  <img
                    src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_double_arrow.svg`}
                    alt="화살표 아이콘"
                  />
                </div>
              </div>
              <div className="qrCode">
                <QRCodeSVG value={qrCodeLink()} />
              </div>
            </div>
          )}
        </div>
      </div>
    );
  };

  const RenderClosedItem = (oProps: { item: OrderDataType; index: number }) => {
    const [remainComment, setRemainComment] = useState<string>(
      getRemainTimeComment(
        oProps.item.order_status,
        oProps.item.order_category,
        oProps.item.delivery_expected_at,
        oProps.item.delivery_completed_at,
        oProps.item.cancelled_at
      )
    );

    useEffect(() => {
      let interval: NodeJS.Timeout;

      interval = setInterval(() => {
        getRemainTimeComment(
          oProps.item.order_status,
          oProps.item.order_category,
          oProps.item.delivery_expected_at,
          oProps.item.delivery_completed_at,
          oProps.item.cancelled_at,
          setRemainComment
        );
      }, 1000);

      return () => {
        clearInterval(interval);
      };
    }, []);

    return (
      <div
        key={oProps.index}
        className="listItem"
        onClick={() => {
          selectOrder(oProps.index);
        }}
      >
        <div className="listLeft">
          <p className="indexBox">{oProps.index + 1}</p>
          <p className="storeName">{getStoreName(oProps.item, lang)}</p>
        </div>
        <p className="orderState">
          {
            getStoreTypeStatus(
              oProps.item.order_category,
              oProps.item.order_status,
              lang
            ).button
          }
        </p>
        <div className="restTime">
          <p className="timeItem">
            <img
              src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_clock.svg`}
              width={18}
              height={18}
              alt="ic"
            />
            {remainComment}
          </p>
        </div>
        <img
          src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_arrow_down.svg`}
          alt="ic"
        />
      </div>
    );
  };

  const RenderOrderItem = useMemo(() => {
    return (
      <>
        <div className="listWrap">
          {orderDataList.map((item: OrderDataType, index: number) => {
            return (
              <div className="maxWidth" key={index} id={"id:" + index}>
                {selectedOrder === index ? (
                  <RenderOpenItem item={item} index={index} />
                ) : (
                  <RenderClosedItem item={item} index={index} />
                )}
              </div>
            );
          })}
        </div>
      </>
    );
  }, [orderDataList, selectedOrder, new Date()]);

  return (
    <Style>
      <div
        className="knockContainer"
        onTouchStart={resetTimer}
        onClick={resetTimer}
        onScrollCapture={resetTimer}
      >
        {master && (
          <div className="header">
            <BackButton pathname="orderStatus" />
            <p className="titleFont">{getStoreName(master, lang)}</p>
            <div />
          </div>
        )}
        <div className="content">{RenderOrderItem}</div>
        <div className="bottomButtonWrap">
          <button
            className="button back"
            onClick={() => {
              navigate(-1);
            }}
          >
            {langText.button_back[lang]}
          </button>
          <button className="button home" onClick={navigateMaster}>
            {langText.orderStatus_button_order[lang]}
          </button>
        </div>
        {/* <div className="footer">
          <div className="mediaWrap">
            {mediaData[currentMediaIndex].type === "image" ? (
              <img src={mediaData[currentMediaIndex].src} alt="img" />
            ) : (
              <video
                ref={videoRef}
                id="adVideo"
                autoPlay={true}
                muted
                onEnded={endVideo}
              >
                <source
                  src={mediaData[currentMediaIndex].src}
                  type="video/mp4"
                />
              </video>
            )}
          </div>
        </div> */}
      </div>
    </Style>
  );
};
export default OrderStatus;

const Style = styled.div`
  .flex {
    display: flex;
    align-items: center;
  }
  .knockContainer {
    min-height: 100vh;
    height: 100%;
    background: #000000;
    display: flex;
    flex-direction: column;
  }
  .backButton {
    position: absolute;
    left: 0;
  }

  .row {
    display: flex;
    align-items: center;
  }
  .row.right {
    padding-top: 3%;
    padding-right: 1%;
    width: 100%;
    justify-content: flex-end;
  }
  .row.gap4 {
    gap: 4px;
  }
  .row.gap8 {
    gap: 8px;
  }
  .row.underGap10 {
    padding-bottom: 10px;
  }
  .row.between {
    justify-content: space-between;
  }

  .maxWidth {
    width: 100%;
    position: relative;
  }

  .header {
    padding-top: 20px;
    margin-left: 4%;
    margin-right: 4%;
    height: 7vh;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    position: relative;
  }
  .titleFont {
    font-size: 24px;
    line-height: 32px;
    font-weight: 200;
    margin: 0 0;
    margin-left: -46px;
    color: #ffffff;
  }
  .content {
    height: 85vh;
    padding-left: 4%;
    padding-right: 4%;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    gap: 4%;
  }

  .listWrap {
    width: 100%;
    height: 100%;
    padding-top: 10px;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;

    .listItem {
      width: 100%;
      display: flex;
      padding: 16px 30px;
      gap: 14px;
      align-items: center;
      background: #343434;
      border-radius: 10px;

      .listLeft {
        flex: 5;
        display: flex;
        gap: 16px;
        align-items: center;
        justify-content: flex-start;
        overflow: hidden;
      }
      .indexBox {
        width: 24px;
        height: 24px;
        border-radius: 4px;
        border: 1px solid #ffffff;
        background: #262626;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 12px;
        line-height: 16px;
        color: #ffffff;
        font-weight: 300;
        margin: 0 0;
      }
      .storeName {
        max-width: 80%;
        font-size: 20px;
        line-height: 24px;
        color: #ffffff;
        font-weight: 500;
        margin: 0 0;
        text-align: left;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .orderState {
        flex: 2;
        font-size: 18px;
        line-height: 24px;
        color: #ffffff;
        font-weight: 400;
        margin: 0 0;
        padding-right: 5%;
        text-align: right;
        white-space: nowrap;
      }
      .restTime {
        flex: 3;
        display: flex;
        align-items: center;
        justify-content: left;
        .timeItem {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 6px;
          font-size: 16px;
          line-height: 22px;
          padding: 1px 10px;
          border: 1px solid #555555;
          border-radius: 50px;
          color: #ffffff;
          font-weight: 300;
          margin: 0 0;
          white-space: nowrap;
        }
      }
    }

    @keyframes fadeIn {
      from {
        opacity: 0;
      }
      to {
        opacity: 1;
      }
    }

    .callNumberBox {
      position: absolute;
      padding: 4px 16px;
      background: #e5e5e5;
      color: #555555;
      border-radius: 50px;
      font-size: 18px;
      line-height: 20px;
      font-weight: 400;
      top: -10px;
      z-index: 2;
      opacity: 0;
    }
    .callNumberBox.visible {
      opacity: 1;
      animation: fadeIn 0.3s ease-in-out;
    }

    .listItem.open {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      background: #40977f;
      border-top-left-radius: 10px;
      border-top-right-radius: 10px;
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;

      .indexBox {
        padding: 12px 10px 10px 10px;
        border: 1px solid rgba(255, 255, 255, 1);
        background: #40977f;
        font-size: 14px;
        line-height: 20px;
        font-weight: 400;
      }

      .storeInfo {
        width: 100%;
        flex: 1;

        .storeName {
          margin: 0 16px 0 27px;
          max-width: 100%;
        }
      }
      .orderDetailButton.cancel {
        display: flex;
        align-items: center;
        gap: 4px;
        margin-right: 16px;
        padding: 7px 14px;
        border: 2px solid #c92929;
        color: #c92929;
        border-radius: 5px;
        font-size: 18px;
        font-weight: 600;

        img {
          width: 24px;
        }
      }
      .orderDetailButton.notice {
        margin-right: 16px;
        padding: 8px 11px;
        border: 1px solid #e5e5e5;
        border-radius: 5px;
        color: #fff;
        font-size: 16px;
        font-weight: 400;
        line-height: 20px;
        white-space: pre;
      }
    }
    .listItem.open.cancel {
      background: #ff4a4a;
      .indexBox {
        background: #ff4a4a;
      }
    }

    @keyframes expandDown {
      0% {
        height: 0;
        opacity: 0;
      }
      100% {
        height: 350px;
        opacity: 1;
      }
    }

    .listContent.active {
      overflow: hidden;
      animation: expandDown 0.5s ease-in-out;
    }
    .listContent {
      padding: 16px 30px;
      width: 100%;
      display: flex;
      flex-direction: column;
      gap: 8px;
      align-items: center;
      background: #343434;
      border-bottom-left-radius: 10px;
      border-bottom-right-radius: 10px;

      .topButtonWrap {
        width: 100%;
        display: flex;
        justify-content: space-between;
        gap: 6px;

        .orderDetailButton,
        .customerButton {
          padding: 8px 20px;
          text-align: center;
          background: #555555;
          border: 1px solid #a7a7a7;
          border-radius: 50px;
          gap: 8px;

          p {
            font-size: 16px;
            font-weight: 600;
            line-height: 24px;
            color: #e5e5e5;
          }
        }
      }

      .loadingDots {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 24px;

        @keyframes bounce {
          20%,
          50%,
          80%,
          100% {
            transform: scale(1);
          }
          40% {
            transform: scale(1.5);
          }
        }
        .dot {
          width: 8px;
          height: 8px;
          border-radius: 50%;
          background-color: #ffffff;
          margin: 12px 0;
          animation: bounce 2s infinite;
        }
        .dot:nth-child(2) {
          animation-delay: 0.5s;
        }
        .dot:nth-child(3) {
          animation-delay: 1s;
        }
      }

      h2 {
        font-size: 32px;
        line-height: 40px;
        font-weight: 500;
        color: #ffffff;
        text-align: center;
        padding: 20px 0 10px 0;
      }
      .cancelNoticeText {
        padding-bottom: 13px;
        font-size: 18px;
        font-weight: 300;
      }

      .statusBox {
        margin-top: 10px;
        width: 100%;
        background: #2b2b2b;
        border-radius: 20px;
        padding: 37px 0 42px 0;

        h3 {
          font-size: 28px;
          font-weight: 600;
          line-height: 39px;
          color: #ffffff;
          white-space: nowrap;
        }
        h4 {
          margin-top: 20px;
          font-size: 18px;
          line-height: 25px;
          font-weight: 500;
          white-space: pre-line;
          color: #a7a7a7;
        }
        .refundButton {
          margin-top: 10px;
          padding: 12px 10%;
          background: #ff4a4a;
          font-size: 20px;
          line-height: 28px;
          border-radius: 10px;
          color: #ffffff;
          font-weight: 500;
          text-align: center;
        }

        .restTime {
          display: flex;
          justify-content: center;
          padding-top: 10px;
          padding-bottom: 10px;
          .timeItem {
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 6px;
            padding: 5px 14px;
            color: #ffffff;
            font-size: 22px;
            line-height: 28px;
            background: #4dd2ae;
            border: 1px solid #4dd2ae;
            border-radius: 50px;
            margin: 0 0;
          }
          .timeItem.inactive {
            background: #a7a7a7;
            border: 1px solid #a7a7a7;
          }
          .timeItem.cancel {
            background: #ff4a4a;
            border: 1px solid #ff4a4a;
          }
        }

        .statusBarWrap {
          width: 100%;
          padding: 20px 20px;
          .statusBar {
            width: 100%;
            height: 12px;
            border-radius: 50px;
            overflow: hidden;
            background: #cfcfcf;
            position: relative;
          }
          .progressBar {
            height: 100%;
            width: 0;
            background: #6fdfc1;
            transition: width 0.3s ease-in-out;
          }
          .statusWrap {
            width: 100%;
            position: relative;
          }
          .statusDotWrap {
            width: 60px;
            position: absolute;
            .statusDot {
              position: absolute;
              top: -12px;
              width: 12px;
              height: 12px;
              border-radius: 100px;
              background: #40977f;
              z-index: 2;
            }
            .statusFont {
              position: absolute;
              left: 5%;
              transform: translateX(-40%);
              font-size: 16px;
              line-height: 32px;
              font-weight: 400;
              white-space: nowrap;
              color: #ffffff;
              margin: 0 0;
            }
          }
        }
      }
    }
  }

  .footer {
    height: 25vh;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    background: #000000;

    h3 {
      background-color: blue;
      color: #ffffff;
    }

    .mediaWrap {
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      width: 100%;
      height: 100%;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }

      video {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }

      p {
        color: red;
      }
    }
  }

  .bottomButtonWrap {
    height: 8vh;
    padding: 0 4%;
    width: 100%;
    display: flex;
    align-items: center;
    gap: 12px;

    button {
      flex: 1;
      padding: 12px 0;
      border-radius: 10px;
      font-size: 20px;
      line-height: 30px;
      font-weight: 600;
      cursor: pointer;
    }
    .back {
      background: #000000;
      border: 2px solid #777777;
      color: #ffffff;
    }
    .home {
      background: #ffffff;
      border: 2px solid #ffffff;
      color: "#000000";
    }
  }

  /* kioskModeWrap */
  .kioskModeWrap {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 40px 70px;
    background: #fff;
    border-radius: 20px;
    gap: 5%;

    .kioskModeLeft {
      text-align: left;
    }
    .roomNumber {
      font-size: 40px;
      font-weight: 700;
      color: #555;
    }
    .qrNoticeText {
      margin: 21px 0;
      font-size: 20px;
      font-weight: 600;
      color: #ff4a4a;
      line-height: 30px;
    }
    p {
      font-size: 16px;
      font-weight: 400;
      color: #a7a7a7;
      line-height: 30px;
    }
    span {
      color: #000;
    }
  }

  .sideButton {
    position: relative;
    display: flex;
    justify-content: center;
    width: 70px;
    height: 70px;
    background: linear-gradient(180deg, #48f8c9 0%, #65b6da 100%);
    border-radius: 100px;
    margin-top: -34px;
    margin-left: -26px;
    img {
      width: 80%;
      height: 80%;
    }
    img.siren {
      position: absolute;
      width: 14px !important;
      height: 14px !important;
      z-index: 3;
      right: 13px;
      bottom: 9px;
    }
    .request {
      position: absolute;
      bottom: -10px;
      background: #ffffff;
      border: 3px solid #65b6da;
      padding: 1px 6px;
      border-radius: 50px;
      white-space: nowrap;
      p {
        font-size: 12px;
        line-height: 16px;
        color: #65b6da;
        font-weight: 500;
      }
    }
  }
  .sideButton.contact {
    background: linear-gradient(180deg, #d186ff 0%, #8a9dff 100%);
    .request {
      border-color: #8a9dff;
      p {
        color: #8a9dff;
      }
    }
  }
`;
